import { Action, createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { Country } from 'src/app/shared/models/setups/geography/country.interface';
import { LoadCountriesSuccess } from './setups.action';

export const SetupsFeatureKey = 'Setups';

export interface SetupsState {
    country: Country[];
    error: string;
}

const InitialState: SetupsState = {
    country: [],
    error: ''
};

export const SetupsReducer = createReducer(
    InitialState,
    on(LoadCountriesSuccess, (state, { country }) => ({
        ...state,
        country,
        error: ''
    })
    )
);

const SetupsSelectors = createFeatureSelector<SetupsState>(SetupsFeatureKey);

export const GetCountry = createSelector(
    SetupsSelectors,
    (state: SetupsState) => {
        return state.country;
    }
);


// tslint:disable-next-line: typedef
export function reducer(state: SetupsState | undefined, action: Action) {
    return SetupsReducer(state, action);
}
